var map = {
	"./AITextDetector": [
		15448,
		9,
		4586
	],
	"./AITextDetector.css": [
		19945,
		9,
		3700
	],
	"./AITextDetector.jsx": [
		15448,
		9,
		4586
	],
	"./ActivityScoreCard": [
		4376,
		9,
		8930,
		2273,
		5970,
		5766,
		8621,
		1238,
		2700,
		9080,
		8689,
		9172,
		5512,
		4268
	],
	"./ActivityScoreCard.jsx": [
		4376,
		9,
		8930,
		2273,
		5970,
		5766,
		8621,
		1238,
		2700,
		9080,
		8689,
		9172,
		5512,
		4268
	],
	"./Admin": [
		37558,
		9,
		8082,
		3952,
		6329,
		684
	],
	"./Admin.jsx": [
		37558,
		9,
		8082,
		3952,
		6329,
		684
	],
	"./AllProposals": [
		9987,
		9,
		2953
	],
	"./AllProposals.css": [
		96242,
		9,
		2515
	],
	"./AllProposals.jsx": [
		9987,
		9,
		2953
	],
	"./Annoucements": [
		68594,
		9,
		5107
	],
	"./Annoucements.jsx": [
		68594,
		9,
		5107
	],
	"./AnnoucementsFeeds": [
		26546,
		9,
		9330
	],
	"./AnnoucementsFeeds.jsx": [
		26546,
		9,
		9330
	],
	"./AppraisalHistory": [
		80467,
		9,
		8930,
		2273,
		4620,
		9372
	],
	"./AppraisalHistory.jsx": [
		80467,
		9,
		8930,
		2273,
		4620,
		9372
	],
	"./AsanaTasksModal": [
		62142,
		9,
		5970,
		5766,
		8621,
		1238,
		3162
	],
	"./AsanaTasksModal.jsx": [
		62142,
		9,
		5970,
		5766,
		8621,
		1238,
		3162
	],
	"./AttendanceCard": [
		91188,
		9,
		8930,
		2273,
		5970,
		5766,
		8621,
		1238,
		2700,
		9080,
		8689,
		9172,
		5512
	],
	"./AttendanceCard.jsx": [
		91188,
		9,
		8930,
		2273,
		5970,
		5766,
		8621,
		1238,
		2700,
		9080,
		8689,
		9172,
		5512
	],
	"./AttendanceReport": [
		61342,
		9,
		8930,
		2273,
		8082,
		3952,
		5970,
		5766,
		8621,
		1238,
		2700,
		9080,
		8689,
		8767,
		1135,
		9752,
		6329,
		2997,
		9172,
		5512,
		1342,
		3704
	],
	"./AttendanceReport.jsx": [
		61342,
		9,
		8930,
		2273,
		8082,
		3952,
		5970,
		5766,
		8621,
		1238,
		2700,
		9080,
		8689,
		8767,
		1135,
		9752,
		6329,
		2997,
		9172,
		5512,
		1342,
		3704
	],
	"./AttendanceReportsHR/AttendanceLog": [
		86582,
		9,
		8082,
		3952,
		691,
		1619,
		5970,
		8643,
		5766,
		733,
		2131,
		5842,
		9223,
		8791,
		9382,
		3722,
		1523,
		6329,
		2997,
		7926,
		3486,
		6935
	],
	"./AttendanceReportsHR/AttendanceLog.jsx": [
		86582,
		9,
		8082,
		3952,
		691,
		1619,
		5970,
		8643,
		5766,
		733,
		2131,
		5842,
		9223,
		8791,
		9382,
		3722,
		1523,
		6329,
		2997,
		7926,
		3486,
		6935
	],
	"./AttendanceReportsHR/ExtraHoursLogs": [
		13128,
		9,
		8082,
		3952,
		6329,
		2997,
		3260
	],
	"./AttendanceReportsHR/ExtraHoursLogs.jsx": [
		13128,
		9,
		8082,
		3952,
		6329,
		2997,
		3260
	],
	"./AttendanceReportsHR/MonthlySummary": [
		615,
		9,
		3927
	],
	"./AttendanceReportsHR/MonthlySummary.jsx": [
		615,
		9,
		3927
	],
	"./AttendanceReportsHR/OvertimeTable": [
		4855,
		9,
		907,
		2313
	],
	"./AttendanceReportsHR/OvertimeTable.jsx": [
		4855,
		9,
		907,
		2313
	],
	"./AttendanceReportsHR/TimeInRecords": [
		97912,
		9,
		8082,
		3952,
		6329,
		2997,
		9958
	],
	"./AttendanceReportsHR/TimeInRecords.jsx": [
		97912,
		9,
		8082,
		3952,
		6329,
		2997,
		9958
	],
	"./AttendanceReportsHR/components/LogCharts": [
		63486,
		9,
		1619,
		8643,
		733,
		2131,
		8791,
		9382,
		3486,
		2576
	],
	"./AttendanceReportsHR/components/LogCharts.jsx": [
		63486,
		9,
		1619,
		8643,
		733,
		2131,
		8791,
		9382,
		3486,
		2576
	],
	"./AttendanceReportsHR/components/LogFilters": [
		19832,
		9,
		3372
	],
	"./AttendanceReportsHR/components/LogFilters.jsx": [
		19832,
		9,
		3372
	],
	"./AttendanceReportsHR/components/LogHeader": [
		44882,
		9,
		4824
	],
	"./AttendanceReportsHR/components/LogHeader.jsx": [
		44882,
		9,
		4824
	],
	"./AttendanceReportsHR/components/LogTable": [
		72441,
		9,
		3701
	],
	"./AttendanceReportsHR/components/LogTable.jsx": [
		72441,
		9,
		3701
	],
	"./AttendanceReportsHR/components/charts/ChartTooltip": [
		22816,
		9,
		2904
	],
	"./AttendanceReportsHR/components/charts/ChartTooltip.jsx": [
		22816,
		9,
		2904
	],
	"./AttendanceReportsHR/components/charts/EffortComparisonChart": [
		89894,
		9,
		1619,
		8643,
		733,
		9382,
		8516
	],
	"./AttendanceReportsHR/components/charts/EffortComparisonChart.jsx": [
		89894,
		9,
		1619,
		8643,
		733,
		9382,
		8516
	],
	"./AttendanceReportsHR/components/charts/OvertimeTrendChart": [
		35283,
		9,
		1619,
		8643,
		733,
		8395
	],
	"./AttendanceReportsHR/components/charts/OvertimeTrendChart.jsx": [
		35283,
		9,
		1619,
		8643,
		733,
		8395
	],
	"./AttendanceReportsHR/components/charts/ProductiveHoursTrend": [
		80634,
		9,
		1619,
		8643,
		8791,
		5282
	],
	"./AttendanceReportsHR/components/charts/ProductiveHoursTrend.jsx": [
		80634,
		9,
		1619,
		8643,
		8791,
		5282
	],
	"./AttendanceReportsHR/components/charts/ProductivityScoreChart": [
		41019,
		9,
		1619,
		8643,
		8791,
		2907
	],
	"./AttendanceReportsHR/components/charts/ProductivityScoreChart.jsx": [
		41019,
		9,
		1619,
		8643,
		8791,
		2907
	],
	"./AttendanceReportsHR/components/charts/StatusOverviewChart": [
		56828,
		9,
		1619,
		2131,
		6666
	],
	"./AttendanceReportsHR/components/charts/StatusOverviewChart.jsx": [
		56828,
		9,
		1619,
		2131,
		6666
	],
	"./AttendanceReportsHR/components/charts/TimeDistributionChart": [
		86374,
		9,
		1619,
		8643,
		733,
		4776
	],
	"./AttendanceReportsHR/components/charts/TimeDistributionChart.jsx": [
		86374,
		9,
		1619,
		8643,
		733,
		4776
	],
	"./AttendanceReportsHR/modalsForAttendance/AttendanceImportModal": [
		87926,
		9,
		5766,
		3722,
		1523,
		7926,
		7426
	],
	"./AttendanceReportsHR/modalsForAttendance/AttendanceImportModal.jsx": [
		87926,
		9,
		5766,
		3722,
		1523,
		7926,
		7426
	],
	"./AttendanceReportsHR/modalsForAttendance/EmployeeAttendanceModal": [
		90747,
		9,
		5766,
		859
	],
	"./AttendanceReportsHR/modalsForAttendance/EmployeeAttendanceModal.jsx": [
		90747,
		9,
		5766,
		859
	],
	"./AttendanceReportsHR/modalsForAttendance/ExportAllEmployeeAttendanceCSV_Fixed": [
		27034,
		9,
		5766,
		900
	],
	"./AttendanceReportsHR/modalsForAttendance/ExportAllEmployeeAttendanceCSV_Fixed.jsx": [
		27034,
		9,
		5766,
		900
	],
	"./AttendanceReportsHR/modalsForAttendance/ExportAllEmployeeAttendanceCSV_New": [
		14594,
		9,
		5842,
		9223,
		5380
	],
	"./AttendanceReportsHR/modalsForAttendance/ExportAllEmployeeAttendanceCSV_New.jsx": [
		14594,
		9,
		5842,
		9223,
		5380
	],
	"./AttendanceTaskModule": [
		86351,
		9,
		8930,
		2273,
		5970,
		5766,
		8621,
		1238,
		9172,
		9105
	],
	"./AttendanceTaskModule.jsx": [
		86351,
		9,
		8930,
		2273,
		5970,
		5766,
		8621,
		1238,
		9172,
		9105
	],
	"./ChatBox": [
		80068,
		9,
		1135,
		1316
	],
	"./ChatBox.css": [
		2163,
		9,
		7530
	],
	"./ChatBox.jsx": [
		80068,
		9,
		1135,
		1316
	],
	"./ChatbotAdmin": [
		27709,
		9,
		1709
	],
	"./ChatbotAdmin.jsx": [
		27709,
		9,
		1709
	],
	"./CircularProgress": [
		3711,
		9,
		7337
	],
	"./CircularProgress.jsx": [
		3711,
		9,
		7337
	],
	"./ClientTaskLog": [
		46503,
		9,
		8767,
		4256,
		1113
	],
	"./ClientTaskLog.jsx": [
		46503,
		9,
		8767,
		4256,
		1113
	],
	"./ColorPicker": [
		81142,
		9,
		9478,
		1278
	],
	"./ColorPicker.css": [
		25461,
		9,
		3424
	],
	"./ColorPicker.jsx": [
		81142,
		9,
		9478,
		1278
	],
	"./ComplainOrSuggestion": [
		51651,
		9,
		1237
	],
	"./ComplainOrSuggestion.jsx": [
		51651,
		9,
		1237
	],
	"./Complaint": [
		91441,
		9,
		8930,
		2273,
		8082,
		691,
		1809,
		6467,
		6329,
		8197,
		2574
	],
	"./Complaint.jsx": [
		91441,
		9,
		8930,
		2273,
		8082,
		691,
		1809,
		6467,
		6329,
		8197,
		2574
	],
	"./ComplaintList": [
		79926,
		9,
		8002
	],
	"./ComplaintList.jsx": [
		79926,
		9,
		8002
	],
	"./Currency": [
		41800,
		9,
		8082,
		3952,
		6329,
		2997,
		578
	],
	"./Currency.jsx": [
		41800,
		9,
		8082,
		3952,
		6329,
		2997,
		578
	],
	"./Customer": [
		48247,
		9,
		8082,
		3952,
		5766,
		7069,
		6329,
		2997,
		1115
	],
	"./Customer.jsx": [
		48247,
		9,
		8082,
		3952,
		5766,
		7069,
		6329,
		2997,
		1115
	],
	"./Dashboard": [
		21035,
		9,
		8930,
		2273,
		8082,
		3952,
		1619,
		5970,
		8643,
		5766,
		8621,
		1238,
		2700,
		9080,
		9382,
		8689,
		8767,
		1135,
		4747,
		9752,
		6329,
		2997,
		9172,
		5512,
		1342,
		2561
	],
	"./Dashboard.jsx": [
		21035,
		9,
		8930,
		2273,
		8082,
		3952,
		1619,
		5970,
		8643,
		5766,
		8621,
		1238,
		2700,
		9080,
		9382,
		8689,
		8767,
		1135,
		4747,
		9752,
		6329,
		2997,
		9172,
		5512,
		1342,
		2561
	],
	"./EditProposal": [
		94792,
		9,
		2700,
		9080,
		5577
	],
	"./EditProposal.jsx": [
		94792,
		9,
		2700,
		9080,
		5577
	],
	"./EmailFeature": [
		32140,
		9,
		9301,
		321
	],
	"./EmailFeature.jsx": [
		32140,
		9,
		9301,
		321
	],
	"./Employee": [
		33147,
		9,
		8082,
		3952,
		1809,
		6329,
		2997,
		5539
	],
	"./Employee.jsx": [
		33147,
		9,
		8082,
		3952,
		1809,
		6329,
		2997,
		5539
	],
	"./EmployeeBirthadyNot": [
		66049,
		9,
		3389
	],
	"./EmployeeBirthadyNot.jsx": [
		66049,
		9,
		3389
	],
	"./EmployeeHandbook": [
		74875,
		9
	],
	"./EmployeeHandbook.jsx": [
		74875,
		9
	],
	"./EmployeeHandbookSimple": [
		88735,
		9,
		3321
	],
	"./EmployeeHandbookSimple.jsx": [
		88735,
		9,
		3321
	],
	"./Employees/Dashboard": [
		7867,
		9,
		1619,
		8643,
		733,
		2131,
		3722,
		8848,
		4746,
		4661
	],
	"./Employees/Dashboard.jsx": [
		7867,
		9,
		1619,
		8643,
		733,
		2131,
		3722,
		8848,
		4746,
		4661
	],
	"./Employees/DocumentRequests": [
		36882,
		9,
		7834
	],
	"./Employees/DocumentRequests.jsx": [
		36882,
		9,
		7834
	],
	"./Employees/EmployeeEdit": [
		68779,
		9,
		8930,
		2273,
		300,
		8553,
		8565,
		235
	],
	"./Employees/EmployeeEdit.jsx": [
		68779,
		9,
		8930,
		2273,
		300,
		8553,
		8565,
		235
	],
	"./Employees/EmployeeExport": [
		81117,
		9,
		5842,
		9223,
		1117,
		433
	],
	"./Employees/EmployeeExport.jsx": [
		81117,
		9,
		5842,
		9223,
		1117,
		433
	],
	"./Employees/EmployeeForm": [
		46353,
		9,
		6957
	],
	"./Employees/EmployeeForm.jsx": [
		46353,
		9,
		6957
	],
	"./Employees/EmployeeShow": [
		79476,
		9,
		691,
		5970,
		5842,
		9223,
		2544,
		1117,
		796
	],
	"./Employees/EmployeeShow.jsx": [
		79476,
		9,
		691,
		5970,
		5842,
		9223,
		2544,
		1117,
		796
	],
	"./Employees/Employees": [
		93936,
		9,
		8930,
		2273,
		691,
		1619,
		8643,
		733,
		2131,
		5842,
		9223,
		3722,
		8848,
		7978,
		1117,
		4746,
		5334,
		5966
	],
	"./Employees/Employees.jsx": [
		93936,
		9,
		8930,
		2273,
		691,
		1619,
		8643,
		733,
		2131,
		5842,
		9223,
		3722,
		8848,
		7978,
		1117,
		4746,
		5334,
		5966
	],
	"./Employees/LeaveBalanceModal": [
		42913,
		9,
		691,
		7907
	],
	"./Employees/LeaveBalanceModal.jsx": [
		42913,
		9,
		691,
		7907
	],
	"./Employees/ProfileDetailsModal": [
		32953,
		9,
		691,
		5334,
		7691
	],
	"./Employees/ProfileDetailsModal.jsx": [
		32953,
		9,
		691,
		5334,
		7691
	],
	"./Employees/SectionApproval": [
		79079,
		9,
		6409
	],
	"./Employees/SectionApproval.jsx": [
		79079,
		9,
		6409
	],
	"./Employees/TeamHierarchy": [
		93615,
		9,
		2297
	],
	"./Employees/TeamHierarchy.jsx": [
		93615,
		9,
		2297
	],
	"./Employees/TemporaryWorkingHoursModal": [
		16965,
		9,
		8930,
		2273,
		5977
	],
	"./Employees/TemporaryWorkingHoursModal.jsx": [
		16965,
		9,
		8930,
		2273,
		5977
	],
	"./ExtraHours": [
		82830,
		9,
		8621,
		2700,
		3072
	],
	"./ExtraHours.jsx": [
		82830,
		9,
		8621,
		2700,
		3072
	],
	"./ExtraHoursApproval": [
		99983,
		9,
		6489
	],
	"./ExtraHoursApproval.jsx": [
		99983,
		9,
		6489
	],
	"./ExtraHoursModal": [
		30631,
		9,
		5179
	],
	"./ExtraHoursModal.jsx": [
		30631,
		9,
		5179
	],
	"./FailedLogsModal": [
		4120,
		9,
		1768
	],
	"./FailedLogsModal.jsx": [
		4120,
		9,
		1768
	],
	"./FeedbackPage": [
		96965,
		9,
		5147
	],
	"./FeedbackPage.jsx": [
		96965,
		9,
		5147
	],
	"./FloatingChatWindow": [
		59117,
		9,
		3143
	],
	"./FloatingChatWindow.jsx": [
		59117,
		9,
		3143
	],
	"./Gallery": [
		58071,
		9
	],
	"./Gallery.jsx": [
		58071,
		9
	],
	"./GenerateEnergySound": [
		83271,
		9
	],
	"./GenerateEnergySound.jsx": [
		83271,
		9
	],
	"./GoogleAuthSignInPage": [
		46773,
		9,
		6500,
		6471
	],
	"./GoogleAuthSignInPage.jsx": [
		46773,
		9,
		6500,
		6471
	],
	"./GoogleKeyWordsPlanner": [
		80204,
		9,
		6500,
		8098
	],
	"./GoogleKeyWordsPlanner.jsx": [
		80204,
		9,
		6500,
		8098
	],
	"./GoogleTrends": [
		50376,
		9,
		8767,
		7970
	],
	"./GoogleTrends.jsx": [
		50376,
		9,
		8767,
		7970
	],
	"./HandbookAcknowledgmentHandler": [
		25964,
		9
	],
	"./HandbookAcknowledgmentHandler.jsx": [
		25964,
		9
	],
	"./HireReq/HireReq": [
		43716,
		9,
		8930,
		2273,
		4830
	],
	"./HireReq/HireReq.jsx": [
		43716,
		9,
		8930,
		2273,
		4830
	],
	"./HireReq/HireReqForm": [
		93703,
		9,
		8930,
		2273,
		3124
	],
	"./HireReq/HireReqForm.jsx": [
		93703,
		9,
		8930,
		2273,
		3124
	],
	"./ImageCollage": [
		82319,
		9,
		5239,
		9861
	],
	"./ImageCollage.css": [
		54622,
		9,
		9079
	],
	"./ImageCollage.jsx": [
		82319,
		9,
		5239,
		9861
	],
	"./InterviewNotifications": [
		60310,
		9
	],
	"./InterviewNotifications.jsx": [
		60310,
		9
	],
	"./Invoice": [
		76826,
		9,
		8930,
		2273,
		8082,
		3952,
		691,
		1809,
		6329,
		8197,
		592
	],
	"./Invoice.jsx": [
		76826,
		9,
		8930,
		2273,
		8082,
		3952,
		691,
		1809,
		6329,
		8197,
		592
	],
	"./LeaveBenefitRequests": [
		33321,
		9,
		691,
		3240
	],
	"./LeaveBenefitRequests.jsx": [
		33321,
		9,
		691,
		3240
	],
	"./LeaveRequestList": [
		80756,
		9,
		691,
		5970,
		2263
	],
	"./LeaveRequestList.jsx": [
		80756,
		9,
		691,
		5970,
		2263
	],
	"./LeaveRequestList_backup": [
		59360,
		9,
		691,
		5970,
		4592
	],
	"./LeaveRequestList_backup.jsx": [
		59360,
		9,
		691,
		5970,
		4592
	],
	"./LeaveSummary": [
		19186,
		9,
		1619,
		8643,
		733,
		2131,
		9382,
		2600
	],
	"./LeaveSummary.jsx": [
		19186,
		9,
		1619,
		8643,
		733,
		2131,
		9382,
		2600
	],
	"./LeavesForm": [
		11355,
		9,
		7225
	],
	"./LeavesForm.jsx": [
		11355,
		9,
		7225
	],
	"./Login": [
		7790,
		9,
		8621,
		7094
	],
	"./Login.jsx": [
		7790,
		9,
		8621,
		7094
	],
	"./Logout": [
		30223,
		9,
		7089
	],
	"./Logout.jsx": [
		30223,
		9,
		7089
	],
	"./MaintenancePlan": [
		70400,
		9,
		8930,
		2273,
		8082,
		691,
		1809,
		1396,
		6329,
		7489,
		8233
	],
	"./MaintenancePlan.jsx": [
		70400,
		9,
		8930,
		2273,
		8082,
		691,
		1809,
		1396,
		6329,
		7489,
		8233
	],
	"./MaintenancePlanNew": [
		72906,
		9,
		8930,
		2273,
		691,
		1809,
		99,
		7489,
		3977
	],
	"./MaintenancePlanNew.jsx": [
		72906,
		9,
		8930,
		2273,
		691,
		1809,
		99,
		7489,
		3977
	],
	"./MetaLengthChecker": [
		89525,
		9,
		3665
	],
	"./MetaLengthChecker.jsx": [
		89525,
		9,
		3665
	],
	"./MyProfile": [
		17688,
		9,
		8930,
		691,
		5970,
		1809,
		8737,
		461,
		2308
	],
	"./MyProfile.jsx": [
		17688,
		9,
		8930,
		691,
		5970,
		1809,
		8737,
		461,
		2308
	],
	"./NotFound": [
		82044,
		9,
		9810
	],
	"./NotFound.jsx": [
		82044,
		9,
		9810
	],
	"./OcrTask": [
		66774,
		9,
		3602
	],
	"./OcrTask.jsx": [
		66774,
		9,
		3602
	],
	"./PageSpeedInsights": [
		87292,
		9,
		7244
	],
	"./PageSpeedInsights.jsx": [
		87292,
		9,
		7244
	],
	"./PaymentInvoice": [
		19422,
		9,
		8930,
		2273,
		8082,
		3952,
		1809,
		6329,
		2997,
		9612
	],
	"./PaymentInvoice.jsx": [
		19422,
		9,
		8930,
		2273,
		8082,
		3952,
		1809,
		6329,
		2997,
		9612
	],
	"./PaymentMode": [
		78849,
		9,
		8082,
		3952,
		6329,
		2997,
		2938
	],
	"./PaymentMode.jsx": [
		78849,
		9,
		8082,
		3952,
		6329,
		2997,
		2938
	],
	"./PrivateNotes": [
		18910,
		9,
		1667
	],
	"./PrivateNotes.jsx": [
		18910,
		9,
		1667
	],
	"./ProductiveHoursClock": [
		11205,
		9,
		6131
	],
	"./ProductiveHoursClock.jsx": [
		11205,
		9,
		6131
	],
	"./Proposal": [
		61217,
		9,
		2700,
		9080,
		300,
		13
	],
	"./Proposal.jsx": [
		61217,
		9,
		2700,
		9080,
		300,
		13
	],
	"./Quote": [
		35387,
		9,
		8930,
		2273,
		8082,
		3952,
		691,
		1809,
		2702,
		6329,
		8197,
		5909
	],
	"./Quote.jsx": [
		35387,
		9,
		8930,
		2273,
		8082,
		3952,
		691,
		1809,
		2702,
		6329,
		8197,
		5909
	],
	"./Recruitment/Recruitment": [
		44964,
		9,
		6500,
		6398
	],
	"./Recruitment/Recruitment.jsx": [
		44964,
		9,
		6500,
		6398
	],
	"./Recruitment/RecruitmentEdit": [
		20016,
		9,
		50
	],
	"./Recruitment/RecruitmentEdit.jsx": [
		20016,
		9,
		50
	],
	"./Recruitment/RecruitmentForm": [
		84490,
		9,
		8308
	],
	"./Recruitment/RecruitmentForm.jsx": [
		84490,
		9,
		8308
	],
	"./Recruitment/RecruitmentInterview": [
		96007,
		9,
		6500,
		5443
	],
	"./Recruitment/RecruitmentInterview.jsx": [
		96007,
		9,
		6500,
		5443
	],
	"./ResetPasswordScreen": [
		34483,
		9
	],
	"./ResetPasswordScreen.jsx": [
		34483,
		9
	],
	"./ReviewAppraisals": [
		8202,
		9,
		8930,
		2273,
		691,
		5274,
		4620,
		9371
	],
	"./ReviewAppraisals.jsx": [
		8202,
		9,
		8930,
		2273,
		691,
		5274,
		4620,
		9371
	],
	"./Role": [
		38858,
		9,
		8082,
		3952,
		6329,
		2997,
		7451
	],
	"./Role.jsx": [
		38858,
		9,
		8082,
		3952,
		6329,
		2997,
		7451
	],
	"./RolePage": [
		60715,
		9,
		9646
	],
	"./RolePage.jsx": [
		60715,
		9,
		9646
	],
	"./Salarymanagement": [
		89612,
		9,
		8930,
		2273,
		1619,
		8643,
		1238,
		2131,
		5842,
		8791,
		4747,
		9186,
		280
	],
	"./Salarymanagement.jsx": [
		89612,
		9,
		8930,
		2273,
		1619,
		8643,
		1238,
		2131,
		5842,
		8791,
		4747,
		9186,
		280
	],
	"./Settings/GeneralSettings": [
		74364,
		9,
		8082,
		9176
	],
	"./Settings/GeneralSettings.jsx": [
		74364,
		9,
		8082,
		9176
	],
	"./Settings/InvoiceSettings": [
		649,
		9,
		8082,
		5457
	],
	"./Settings/InvoiceSettings.jsx": [
		649,
		9,
		8082,
		5457
	],
	"./Settings/PaymentSettings": [
		99378,
		9,
		8930,
		2273,
		8082,
		3952,
		7642,
		6329,
		2997,
		5410
	],
	"./Settings/PaymentSettings.jsx": [
		99378,
		9,
		8930,
		2273,
		8082,
		3952,
		7642,
		6329,
		2997,
		5410
	],
	"./Settings/Settings": [
		30612,
		9,
		8930,
		2273,
		8082,
		3952,
		7642,
		6329,
		2997,
		8950
	],
	"./Settings/Settings.jsx": [
		30612,
		9,
		8930,
		2273,
		8082,
		3952,
		7642,
		6329,
		2997,
		8950
	],
	"./Settings/components/SelectCurrency": [
		95376,
		9,
		3083
	],
	"./Settings/components/SelectCurrency/": [
		95376,
		9,
		3083
	],
	"./Settings/components/SelectCurrency/currenciesList": [
		52725,
		9,
		7421
	],
	"./Settings/components/SelectCurrency/currenciesList.js": [
		52725,
		9,
		7421
	],
	"./Settings/components/SelectCurrency/index": [
		95376,
		9,
		3083
	],
	"./Settings/components/SelectCurrency/index.jsx": [
		95376,
		9,
		3083
	],
	"./Settings/components/SetingsSection": [
		75576,
		9,
		934
	],
	"./Settings/components/SetingsSection.jsx": [
		75576,
		9,
		934
	],
	"./SignUpEmployee": [
		12568,
		9,
		8930,
		2273,
		300,
		8553,
		8565,
		2463
	],
	"./SignUpEmployee.jsx": [
		12568,
		9,
		8930,
		2273,
		300,
		8553,
		8565,
		2463
	],
	"./SuggestionList": [
		96805,
		9,
		1307
	],
	"./SuggestionList.jsx": [
		96805,
		9,
		1307
	],
	"./SuggestionsComplaintForm": [
		22018,
		9,
		275
	],
	"./SuggestionsComplaintForm.jsx": [
		22018,
		9,
		275
	],
	"./TechnicianLogs": [
		34391,
		9,
		5970,
		3722,
		6056
	],
	"./TechnicianLogs.jsx": [
		34391,
		9,
		5970,
		3722,
		6056
	],
	"./TestHandbook": [
		23057,
		9,
		5935
	],
	"./TestHandbook.jsx": [
		23057,
		9,
		5935
	],
	"./URL": [
		67954,
		9
	],
	"./URL.css": [
		87017,
		9,
		980
	],
	"./URL.jsx": [
		67954,
		9
	],
	"./UsersList": [
		53681,
		9,
		4113
	],
	"./UsersList.jsx": [
		53681,
		9,
		4113
	],
	"./VoiceOverElevenLabs": [
		81190,
		9,
		8737,
		118
	],
	"./VoiceOverElevenLabs.jsx": [
		81190,
		9,
		8737,
		118
	],
	"./VoiceOvers": [
		14282,
		9,
		6440
	],
	"./VoiceOvers.jsx": [
		14282,
		9,
		6440
	],
	"./logo.png": [
		65562,
		1,
		3172
	],
	"./responsive.css": [
		86202,
		9
	],
	"./style.css": [
		13465,
		9
	],
	"./textDectect-fileUpload": [
		41428,
		9,
		2006
	],
	"./textDectect-fileUpload.jsx": [
		41428,
		9,
		2006
	],
	"./textToSpeech/slectCountory": [
		76164,
		9,
		5716
	],
	"./textToSpeech/slectCountory.jsx": [
		76164,
		9,
		5716
	],
	"./textToSpeech/voices": [
		40916,
		9,
		8737,
		5057
	],
	"./textToSpeech/voices.jsx": [
		40916,
		9,
		8737,
		5057
	],
	"./uploadFileToDetectText.css": [
		35326,
		9,
		4303
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 50629;
module.exports = webpackAsyncContext;